export const addManagedEventListener = (emitter, eventName, listener, abortSignal) => {
    if (!abortSignal.aborted) {
        emitter.on(eventName, listener);
        abortSignal.addEventListener('abort', () => {
            emitter.off(eventName, listener);
        }, {
            once: true
        });
    }
};
//# sourceMappingURL=addManagedEventListener.js.map